/**
 * Draft service — API calls for draft CRUD.
 */
import { getApiClient } from './api'

export interface DraftSettings {
  platform?: string
  tone?: number
  length?: string
  language?: string
  audience?: string
  custom_instructions?: string
  use_voice?: boolean
  [key: string]: unknown   // forward-compat: unknown fields silently ignored
}

export interface Draft {
  draft_id: string
  item_id: string
  item_url: string
  item_title: string
  post_text: string
  settings: DraftSettings
  created_at: string
}

const api = () => getApiClient()

export async function createDraft(params: {
  item_id: string
  item_url: string
  item_title: string
  post_text: string
  settings: DraftSettings
}): Promise<Draft> {
  const res = await api().post<Draft>('/api/v1/drafts', params)
  return res.data
}

export async function listDraftsForItem(item_id: string): Promise<Draft[]> {
  const res = await api().get<Draft[]>('/api/v1/drafts', { params: { item_id } })
  return res.data
}

export async function listAllDrafts(): Promise<Draft[]> {
  const res = await api().get<Draft[]>('/api/v1/drafts/all')
  return res.data
}

export async function getDraftedItemIds(): Promise<Set<string>> {
  const res = await api().get<{ item_ids: string[] }>('/api/v1/drafts/items')
  return new Set(res.data.item_ids)
}

export async function deleteDraft(draft_id: string): Promise<void> {
  await api().delete(`/api/v1/drafts/${draft_id}`)
}
